import { EntityConfig } from "./EntityConfig";
var EntityMapping = (function () {
    function EntityMapping(instance, args) {
        if (args === void 0) { args = {}; }
        this.instance = instance;
        this.dataBlob = args;
    }
    EntityMapping.prototype.map = function (opts) {
        var _this = this;
        this.entityConfig.eachField(function (fieldConfig) {
            var value = _this.extractValueFromBlob(fieldConfig);
            if ((opts === null || opts === void 0 ? void 0 : opts.onlyProvided) && !(fieldConfig.name in _this.dataBlob)) {
                return;
            }
            if (value === null && !fieldConfig.nullable) {
                return;
            }
            _this.assign(fieldConfig, value);
        });
    };
    EntityMapping.prototype.extractValueFromBlob = function (fieldConfig) {
        return fieldConfig.deserialize(this.dataBlob[fieldConfig.name]);
    };
    EntityMapping.prototype.assign = function (field, data) {
        this.instance[field.name] = data;
    };
    Object.defineProperty(EntityMapping.prototype, "entityConfig", {
        get: function () {
            return EntityConfig.forInstance(this.instance);
        },
        enumerable: false,
        configurable: true
    });
    return EntityMapping;
}());
export { EntityMapping };
